export const ru = {
    'single-rate-max-price':
        'Единая ставка не должна быть больше {maxValue} {currency}',
    'single-rate-min-price':
        'Единая ставка не должна быть меньше {minValue} {currency}'
};
